import React from 'react';
import Store from 'store';
import { connect } from 'react-redux';
import gostoreLogoSmall from 'assets/images/backoffice/online-store/gostore-logo-small.svg';
import gostoreCarousel1 from 'assets/images/backoffice/online-store/gostore-carousel-1-eng.png';
import gostoreCarousel2 from 'assets/images/backoffice/online-store/gostore-carousel-2-eng.png';
import gostoreCarousel3 from 'assets/images/backoffice/online-store/gostore-carousel-3-eng.png';
import gostoreCarousel4 from 'assets/images/backoffice/online-store/gostore-carousel-4-eng.png';
import gostoreCarousel5 from 'assets/images/backoffice/online-store/gostore-carousel-5-eng.png';
import LandingPage from 'pages/OnlineStore/LandingPage/LandingPage';
import isExperienceComplete from 'selectors/isExperienceComplete';
import { completeExperience } from 'reducers/ftue/actions';
import { FTUE_ONLINE_STORE_GO_STORE_RED_DOT } from 'reducers/ftue/ftueKeys';
import { showUpdateRequiredModal } from 'actions/onlineStore';
import * as goStoreClevertap from 'clevertap/onlineStore/gostore';
import find from 'lodash/find';
import styles from './GoStore.css';

const landingPageProps = {
  icons: [gostoreLogoSmall],
  iconClassName: styles.icon,
  pageTitle: '',
  headingText: 'Selling online have never been easier with GoStore!',
  headingDescription:
    'Create your own store website and start selling online effortlessly. Manage your inventory through the Moka Items Library and receive orders through the Moka POS app. Reach millions of customers and gain higher revenue for your business.',
  carouselImages: [
    gostoreCarousel1,
    gostoreCarousel2,
    gostoreCarousel3,
    gostoreCarousel4,
    gostoreCarousel5,
  ],
  ctaText: 'Manage',
  ctaClassName: styles.cta,
  tncText: (
    <div className={styles['tnc-text']}>
      By clicking <b>Manage</b>, you agree to GoStore’s{' '}
      <a href="https://www.mokapos.com/terms-gostore/" target="_blank">
        Terms and Conditions
      </a>
      .
    </div>
  ),
  howToUrl: 'https://mokaposhelp.zendesk.com/hc/id',
  howToDescription:
    'Build your own online store with GoStore in minutes for free!*',
  howToItems: [
    'A personalized website means a personalized domain. Pick your own domain now!',
    'Your products will be easily discoverable through Facebook and Instagram.',
    'Integrated with reliable payment and logistic services, no third party required!',
    'Receive and manage orders through Moka POS app.',
  ],
  carouselPreviewClassName: styles['carousel-preview'],
};

class GoStore extends React.Component {
  componentDidMount() {
    if (this.props.showRedDot) {
      this.props.dispatch(
        completeExperience(FTUE_ONLINE_STORE_GO_STORE_RED_DOT)
      );
    }

    goStoreClevertap.goStoreStart(this._getBusiness());
  }

  render() {
    return (
      <div className={styles.container}>
        <LandingPage
          {...landingPageProps}
          onClick={this._handleLandingPageConnectGoStore}
        />
      </div>
    );
  }

  _handleLandingPageConnectGoStore = () => {
    const { business } = this.props;

    if (!business.name) {
      this.props.dispatch(showUpdateRequiredModal());
      return;
    }

    goStoreClevertap.goStoreLaunch(this._getBusiness());

    const accessToken = Store.get('moka:accessToken');
    window.open(
      `${process.env.GOSTORE_AUTH_URL}?token=${accessToken}`,
      '_blank'
    );
  };

  _getBusiness = () => {
    const { business, businessCategories, email } = this.props;

    const businessCategory = find(businessCategories, {
      id: business.business_category_id,
    });

    business.category = businessCategory ? businessCategory.name : '';
    business.email = email;

    return business;
  };
}

function mapStateToProps(state) {
  const { user, businessCategoriesAllState } = state.moka;

  return {
    business: user.business,
    email: user.email,
    businessCategories: businessCategoriesAllState,
    showRedDot: isExperienceComplete(state, FTUE_ONLINE_STORE_GO_STORE_RED_DOT),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GoStore);
